import { render } from "./PicksGamesPanel.vue?vue&type=template&id=5097cfea&scoped=true"
import script from "./PicksGamesPanel.vue?vue&type=script&lang=js"
export * from "./PicksGamesPanel.vue?vue&type=script&lang=js"

import "./PicksGamesPanel.vue?vue&type=style&index=0&id=5097cfea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5097cfea"]])

export default __exports__